import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationService } from './modules/authentication/authentication.service';
import {
  ActivatedRoute,
  NavigationEnd,
  PRIMARY_OUTLET,
  Router,
  UrlSegment,
  UrlSegmentGroup,
  UrlTree,
} from '@angular/router';
import { UserService } from './services/user/user.service';
import { PAGES } from './constants/route.constants';
import { filter, Subject, takeUntil } from 'rxjs';
import { LandingService } from './services/landing.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  public isMenuCollapsed = true;
  public isLoggedIn = false;
  public currentRoutePath!: PAGES;
  private destroy$: Subject<void> = new Subject<void>();
  protected readonly PAGES = PAGES;

  constructor(
    public userService: UserService,
    public landingService: LandingService,
    private routerRef: Router,
    private authService: AuthenticationService,
  ) {}

  ngOnInit(): void {
    this.authService.registerMsalBroadcast();
    // Watch for login status changes
    this.authService.isLoggedIn.subscribe((isLoggedIn) => {
      if (isLoggedIn) {
        this.isLoggedIn = isLoggedIn;
        this.getLoggedInUserDetails();
      }
    });
    this.routerRef.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$),
      )
      .subscribe(() => {
        this.setCurrentRoutePath();
        // Scroll to the top of the document's primary content area
        document.getElementsByTagName('main')?.[0]?.scrollTo(0, 0);
      });
      // this.landingService.getClientList().subscribe();
  }

  setCurrentRoutePath(): void {
    const segments = this.getSegmentsFromUrl();
    const [currentPathWithoutOrigin] = segments?.map(
      (segment) => segment.path,
    ) || [''];
    this.currentRoutePath = currentPathWithoutOrigin as PAGES;
  }

  getSegmentsFromUrl(): UrlSegment[] | undefined {
    const urlTree: UrlTree = this.routerRef?.parseUrl(this.routerRef?.url);
    const urlSegmentGroup: UrlSegmentGroup =
      urlTree?.root?.children?.[PRIMARY_OUTLET];
    return urlSegmentGroup?.segments;
  }

  getLoggedInUserDetails(): void {
    this.userService.getUserDetails().subscribe();
  }

  getMenuToggleChange(isMenuCollapsed: boolean) {
    this.isMenuCollapsed = isMenuCollapsed;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
